import { baseApi } from "app/baseApi";
import { apiTags } from "app/store/apiTags";

const apiPrefix = 'vendorContact';
export const vendorContactApi = baseApi.injectEndpoints({
    reducerPath: 'loadApi',
    endpoints: (builder) => ({
        getVendorContact: builder.query({
            query: (vendorId) => `${apiPrefix}/${vendorId}`,
            providesTags: [apiTags.VENDOR_CONTACT]
        }),
        addContact: builder.mutation({
            query: (body) => ({
                url: `${apiPrefix}`,
                method: "POST",
                body
            }),
            invalidatesTags: [apiTags.VENDOR_CONTACT]
        }),
        updateContact: builder.mutation({
            query: body => ({
                url: `${apiPrefix}`,
                method: "PUT",
                body
            }),
            invalidatesTags: [apiTags.VENDOR_CONTACT]
        }),
        deleteContact: builder.mutation({
            query: (id) => ({
                url: `${apiPrefix}`,
                method: "DELETE",
                body: { id }
            }),
            invalidatesTags: [apiTags.VENDOR_CONTACT]
        })
    })
});


export const {
    useGetVendorContactQuery,
    useAddContactMutation,
    useUpdateContactMutation,
    useDeleteContactMutation
} = vendorContactApi;
